$(function(){
    
 
 $.fn.myCircleProgress=function(time_end,howlong,timeHandler){
    if(getCurrentTime()>=time_end){
        return this;
    }
    if(!timeHandler){
        timeHandler=_moduleTimeHandler;
    }
    var th=$(this),canvObj,ctx,size={};
    th.addClass("myCircleProgress");
    function init(){
        var html="<canvas></canvas>";
        size={width:th.width(),height:th.height()};
        canvObj=th.html(html).find("canvas").attr(size);
        ctx=canvObj[0];
        ctx=ctx.getContext("2d");
    };
    init();
    var main=th,data=main.data("myCircleP");
    var timeIndex;
    
    if(!data){
        timeIndex=timeHandler.getNewIndex();
        data={"timeIndex":timeIndex};
        main.data("myCircleP",data);
    }
    else{
        timeIndex=data.timeIndex;
        timeHandler.clear(timeIndex);
    }
    
    function prepareView(deg){
        deg=Math.min(360,deg);
        deg=Math.max(0,deg);
        deg=deg%360;
        ctx.clearRect(0, 0, size.width, size.height);
        ctx.save();
        ctx.beginPath();
        ctx.fillStyle = "black";
        ctx.globalAlpha = 0.5;
        ctx.moveTo(size.width/2, size.height/2);
        ctx.arc(size.width/2, size.height/2, size.width, -Math.PI/2, deg/180*Math.PI-Math.PI/2);
        ctx.fill();
        ctx.restore();
    }
    function startAnim(){
        var miliStart=(time_end-howlong)*1000,miliEnd=time_end*1000;

        if(miliStart<miliEnd){
            timeHandler.set(timeIndex,function(){
                var miliCur=new Date().getTime();
                if(miliCur<miliEnd){
                    prepareView((howlong-(miliEnd-miliCur)/1000)/howlong*360);
                }
                else{
                    timeHandler.clear(timeIndex);
                }
                
            },40,function(){
                main.trigger("end");
                canvObj.remove();
            });
        }
        
    }
    startAnim();


    return this;
}
    
});